module.exports = __webpack_public_path__ + "static/cat-60444762b9dffcdc2ac3c2c47e34b703.svg";